import type {SupportedLocale} from './i18n/generated';
import appStoreBadge from './assets/store-badges/apple/app-store-badge.svg';
import googlePlayArabic from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Arabic-Saudi-Arabia.svg';
import googlePlayChineseChina from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Chinese-China.svg';
import googlePlayChineseTaiwan from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Chinese-Taiwan.svg';
import googlePlayDutch from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Dutch.svg';
import googlePlayEnglish from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_English.svg';
import googlePlayFrench from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_French.svg';
import googlePlayGerman from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_German.svg';
import googlePlayHebrew from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Hebrew.svg';
import googlePlayHindi from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Hindi.svg';
import googlePlayIndonesian from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Indonesian.svg';
import googlePlayItalian from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Italian.svg';
import googlePlayJapanese from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Japanese.svg';
import googlePlayKorean from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Korean.svg';
import googlePlayPolish from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Polish.svg';
import googlePlayPortugueseBrazil from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Portuguese-Brazil.svg';
import googlePlayRussian from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Russian.svg';
import googlePlaySpanish from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Spanish.svg';
import googlePlayTurkish from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Turkish.svg';
import googlePlayUkrainian from './assets/store-badges/google/GetItOnGooglePlay_Badge_Web_color_Ukranian.svg';
import ruStoreBadge from './assets/store-badges/rustore/rustore-badge-ru.svg';

export const STORE_LINKS = {
  appStore: 'https://apps.apple.com/us/app/vritti-app/id6745328228',
  freedivingAppStore:
    'https://apps.apple.com/us/app/vritti-breathwork-pranayama/id6745328228?ppid=607ce215-9dcc-4525-aeb0-f2c12bf7fcdf',
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.pranayamaapp',
  ruStore:
    'https://www.rustore.ru/catalog/app/com.pranayamaapp?_rsc=zlniv',
} as const;

export const APP_STORE_BADGE = appStoreBadge;
export const RUSTORE_BADGE = ruStoreBadge;

export const GOOGLE_PLAY_BADGES: Record<SupportedLocale, string> = {
  en: googlePlayEnglish,
  es: googlePlaySpanish,
  ru: googlePlayRussian,
  uk: googlePlayUkrainian,
  fr: googlePlayFrench,
  de: googlePlayGerman,
  it: googlePlayItalian,
  'pt-BR': googlePlayPortugueseBrazil,
  pl: googlePlayPolish,
  nl: googlePlayDutch,
  ar: googlePlayArabic,
  he: googlePlayHebrew,
  hi: googlePlayHindi,
  id: googlePlayIndonesian,
  ja: googlePlayJapanese,
  ko: googlePlayKorean,
  tr: googlePlayTurkish,
  'zh-CN': googlePlayChineseChina,
  'zh-TW': googlePlayChineseTaiwan,
};
